import { render, staticRenderFns } from "./Editbusiness.vue?vue&type=template&id=e3b47d86&scoped=true&"
import script from "./Editbusiness.vue?vue&type=script&lang=js&"
export * from "./Editbusiness.vue?vue&type=script&lang=js&"
import style0 from "./Editbusiness.vue?vue&type=style&index=0&id=e3b47d86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b47d86",
  null
  
)

export default component.exports